import { getBaseURL } from '@mi-front/core';
import { createSerializer, parseAsString } from 'nuqs';
import { loggerStreamSearchParsers } from './logger-stream-params';

/** Path prefix for logger stream routes: /logger/s/:slug */
export const LOGGER_STREAM_PATH = '/logger/s';

/**
 * Parser map for building logger stream URLs. Extends shared stream params with tab (audit tabs).
 * createSerializer uses the same serialization as useLoggerParams for cursor, from, to, selection.
 */
const loggerStreamUrlParsers = {
  ...loggerStreamSearchParsers,
  tab: parseAsString,
};

const serializeLoggerStreamParams = createSerializer(loggerStreamUrlParsers);

/** Params that can be serialized into the logger stream URL. Matches parser map. */
export interface LoggerStreamUrlParams {
  cursor?: number | null;
  from?: number | null;
  to?: number | null;
  selection?: { from: number; to: number } | null;
  focusStart?: number | null;
  /** Audit tab on stream (e.g. livementions, adoverlay, audiomatches). */
  tab?: string | null;
}

/**
 * Builds a logger stream URL for navigation or clipboard.
 * Uses nuqs createSerializer with the same parsers as useLoggerParams so format stays consistent.
 *
 * @param stationSlug - Station slug (route is /logger/s/:slug).
 * @param params - Optional cursor, from, to, selection, tab.
 * @param options.absolute - If true, prepends getBaseURL() for clipboard/share links.
 */
export function buildLoggerStreamUrl(
  stationSlug: string,
  params: LoggerStreamUrlParams = {},
  options?: { absolute?: boolean },
): string {
  const path = `${LOGGER_STREAM_PATH}/${stationSlug}`;
  const search = serializeLoggerStreamParams(params);
  const pathAndSearch = search && search !== '?' ? `${path}${search}` : path;
  return options?.absolute ? `${getBaseURL()}${pathAndSearch}` : pathAndSearch;
}
